// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3928":"plone-volto-components-theme-InjectPloneComponentsCSS-InjectPloneComponentsCSS","4328":"Widgets","5772":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"3928":"98a03066","4328":"62da82f2","5772":"62da82f2"}[chunkId] + ".chunk.css";
};